export default __webpack_public_path__ + "images/2458bd9f90822ee279e639d191b5ca5d.png";